module.exports = "<div class=\"rg-ports-overview\"></div>\n<a href=\"{{portsDetailsUrl|e('html_attr')}}\" class=\"btn btn-primary btn-sm hidden\">{{t('itemsList.moreInfo')|e}}</a>\n";
